import { c as _c } from "react/compiler-runtime";
import { Box, Button, Center, Text, VStack } from '@chakra-ui/react';
import { EngagementNavListItemTitle } from '@src/components/sco/Advisors/layout/EngagementNavListItemTitle';
import { teamAdvisorBadgeForName } from '@src/components/sco/Advisors/model/access';
import { ConversationRow, conversationRowKey } from '@src/components/sco/Advisors/utils/conversationRows';
import { engagementCategoryBadge, engagementDisplayName } from '@src/components/sco/Advisors/utils/mapEngagements';
import { founderDisplayName, founderUserIdOf } from '@src/components/sco/Advisors/utils/mapFounderEngagements';
import { ReactNode } from 'react';

/**
 * Inbox conversation column: one scrolling list of everyone you can talk to.
 *
 * Unlike the old sidebar this is not truncated — no top-N window, no
 * "View All…" overflow. Rows are already sorted and deduped upstream.
 */
export const ConversationList = t0 => {
  const $ = _c(15);
  const {
    rows,
    selectedKey,
    onSelect,
    emptyMessage: t1,
    emptyFooter,
    listFooter
  } = t0;
  const emptyMessage = t1 === undefined ? "No conversations yet." : t1;
  if (rows.length === 0) {
    let t2;
    if ($[0] !== emptyMessage) {
      t2 = <Text color="colorPalette.fg/60" fontSize="sm" textAlign="center">{emptyMessage}</Text>;
      $[0] = emptyMessage;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== emptyFooter || $[3] !== t2) {
      t3 = <Center padding={6}><VStack gap={4} maxWidth="xs">{t2}{emptyFooter}</VStack></Center>;
      $[2] = emptyFooter;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t2;
  if ($[5] !== onSelect || $[6] !== rows || $[7] !== selectedKey) {
    let t3;
    if ($[9] !== onSelect || $[10] !== selectedKey) {
      t3 = row => {
        const key = conversationRowKey(row);
        const isActive = key === selectedKey;
        let title;
        if (row.kind === "locked") {
          title = <EngagementNavListItemTitle locked={true} avatarUrl={row.advisor.avatarUrl} badge={row.advisor.badge} name={row.advisor.name} userId={row.advisor.userId} />;
        } else {
          if (row.kind === "founder") {
            const name = founderDisplayName(row.engagement);
            title = <EngagementNavListItemTitle avatarUser={row.engagement.founderUser || undefined} badge="" engagement={row.engagement} name={name} userId={founderUserIdOf(row.engagement)} />;
          } else {
            if (row.kind === "direct") {
              title = <EngagementNavListItemTitle avatarUrl={row.pictureUrl} badge="" name={row.name} userId={row.userId} />;
            } else {
              const name_0 = engagementDisplayName(row.engagement);
              title = <EngagementNavListItemTitle badge={teamAdvisorBadgeForName(name_0) || engagementCategoryBadge(row.engagement).label} engagement={row.engagement} name={name_0} userId={row.engagement.advisorUser?.userId} />;
            }
          }
        }
        return <Button key={key} _hover={{
          bg: isActive ? "bg.muted" : "bg.muted/70"
        }} bg={isActive ? "bg.muted" : "transparent"} height="auto" justifyContent="flex-start" paddingX={2} paddingY={2} variant="ghost" width="full" onClick={() => onSelect(row)}><Box flex={1} minWidth={0} textAlign="start">{title}</Box></Button>;
      };
      $[9] = onSelect;
      $[10] = selectedKey;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = rows.map(t3);
    $[5] = onSelect;
    $[6] = rows;
    $[7] = selectedKey;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[12] !== listFooter || $[13] !== t2) {
    t3 = <VStack align="stretch" gap={0} padding={1.5} width="full">{t2}{listFooter}</VStack>;
    $[12] = listFooter;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};